import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NeptuneApi } from '../genericApi/neptune.api';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { SystemNotificationApiModel } from './models/system-notification.api.model';

@Injectable()
export class SystemNotificationApi {
    constructor(private neptuneApi: NeptuneApi) {}

    /**
     * Get a list of notifications
     */
    public getList(): Observable<SystemNotificationApiModel[]> {
        return this.neptuneApi.api<SystemNotificationApiModel[]>(
            '/system-notifications',
            null,
            HttpVerbsEnum.GET
        );
    }
    /**
     * Get a notification
     */
    public get(id: number): Observable<SystemNotificationApiModel> {
        return this.neptuneApi.api<SystemNotificationApiModel>(
            `/system-notifications/${id}`,
            null,
            HttpVerbsEnum.GET
        );
    }
    /**
     * Create a notification
     */
    public create(notification: SystemNotificationApiModel): Observable<number> {
        return this.neptuneApi.api<number>(
            '/system-notifications',
            notification,
            HttpVerbsEnum.POST
        );
    }

    /**
     * Update an existing notification
     *
     */
    public update(notification: SystemNotificationApiModel): Observable<number> {
        return this.neptuneApi.api<number>(
            `/system-notifications/${notification.id}`,
            notification,
            HttpVerbsEnum.PUT
        );
    }
    /**
     * Delete a notification
     */
    public delete(id: number): Observable<void> {
        return this.neptuneApi.api<void>(
            `/system-notifications/${id}`,
            null,
            HttpVerbsEnum.DELETE
        );
    }
}
